import React from 'react';
import styled from 'styled-components';

const SpinnerWrapper = styled.svg`
  animation: rotate 1s linear infinite;
  width: 64px;
  height: 64px;
  margin: auto;

  & .path {
    stroke: #000000;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;

export const Spinner: React.FC = () => {
  return (
    <SpinnerWrapper>
      <circle
        className="path"
        cx="32"
        cy="32"
        r="20"
        fill="none"
        strokeWidth="3"
      />
    </SpinnerWrapper>
  );
};
